import { Button } from '@/components/ui/button'
import { Check, Copy } from 'lucide-react'
import { useState } from 'react'
import copy from 'copy-to-clipboard'

export function copyToClipboard(text: string): boolean {
  return copy(text)
}

interface CopyButtonProps {
  value: string
  ariaLabel?: string
  variant?: 'ghost' | 'outline' | 'default' | 'secondary' | 'destructive' | 'link'
  size?: 'default' | 'sm' | 'lg' | 'icon' | 'icon-sm'
  className?: string
  /** External copied state for controlled mode */
  copied?: boolean
  /** Callback when copy is triggered (for controlled mode) */
  onCopy?: () => void
}

export function CopyButton({
  value,
  ariaLabel = 'Copy to clipboard',
  variant = 'ghost',
  size = 'icon-sm',
  className = 'text-muted-foreground',
  copied: controlledCopied,
  onCopy,
}: CopyButtonProps) {
  const [internalCopied, setInternalCopied] = useState(false)

  // Use controlled state if provided, otherwise use internal
  const isControlled = controlledCopied !== undefined
  const copied = isControlled ? controlledCopied : internalCopied

  const handleCopy = () => {
    if (!value) return

    const success = copyToClipboard(value)
    if (success) {
      if (onCopy) {
        onCopy()
      }
      if (!isControlled) {
        setInternalCopied(true)
        setTimeout(() => setInternalCopied(false), 2000)
      }
    }
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handleCopy}
      aria-label={ariaLabel}
    >
      {copied ? (
        <Check className="h-3 w-3" />
      ) : (
        <Copy className="h-3 w-3" />
      )}
    </Button>
  )
}
